export class AnnouncementModel {
    cabsIds: number[] = new Array();
    text: string;
}
